(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/fade-in-slide-wrapper.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/fade-in-slide-wrapper.js');
'use strict';


const animate = refs => {
  const animations = refs.map(ref => {
    const tl = gsap.timeline({
      paused: true
    });
    tl.set(ref, {
      paddingTop: 10,
      opacity: 0
    });
    tl.to(ref, {
      opacity: 1,
      duration: 0.5,
      paddingTop: 0
    });
    tl.progress(0.00001);
    return tl;
  });
  animations.forEach((tl, index) => {
    if (index < animations.length - 1) {
      tl.eventCallback('onUpdate', function () {
        if (tl.progress() > 0.2 && !this.triggered) {
          animations[index + 1].play();
          this.triggered = true;
        }
      });
    }
  });
  setTimeout(() => {
    animations[0].play();
  }, 150);
};

const FadeInSlideWrapper = _ref => {
  let {
    children
  } = _ref;
  const childCount = React.Children.count(children);
  const refs = React.useRef(Array.from({
    length: childCount
  }, () => null));
  const [ids] = React.useState(Array.from({
    length: childCount
  }, () => Math.random()));
  React.useLayoutEffect(() => {
    animate(refs.current);
  }, []);
  return React.createElement(React.Fragment, null, React.Children.map(children, (child, index) => React.createElement("div", {
    key: ids[index],
    ref: el => {
      refs.current[index] = el;
    }
  }, child)));
};
svs.playerRegistration.components.FadeInSlideWrapper = FadeInSlideWrapper;

 })(window);